/**
 * Collection AI Title Generator
 * Generates engaging titles for collection banners
 */

(function() {
  'use strict';

  const OPENAI_PROXY = 'https://dolce-openai-proxy.vercel.app/api/chat';

  class CollectionAIGenerator {
    constructor() {
      this.init();
    }

    init() {
      console.log('🎨 Collection AI Generator initialized');

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.generateTitles());
      } else {
        this.generateTitles();
      }
    }

    async generateTitles() {
      const banners = document.querySelectorAll('[data-collection-ai-title]');

      if (banners.length === 0) {
        console.log('ℹ️ No collection AI banners found');
        return;
      }

      console.log(`🎯 Found ${banners.length} collection banner(s)`);

      for (const banner of banners) {
        await this.generateTitle(banner);
      }
    }

    async generateTitle(element) {
      const productId = element.dataset.productId;
      const productTitle = element.dataset.productTitle;
      const productTags = element.dataset.productTags;
      const collectionTitle = element.dataset.collectionTitle;

      // Check cache
      const cacheKey = `collection_ai_title_${productId}`;
      const cached = localStorage.getItem(cacheKey);

      if (cached) {
        try {
          const data = JSON.parse(cached);
          if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) { // 7 days
            console.log('✅ Using cached title for:', productTitle);
            element.textContent = data.title;
            return;
          }
        } catch (e) {
          console.warn('Cache parse error:', e);
        }
      }

      // Generate new title
      console.log('🤖 Generating AI title for:', productTitle);

      const prompt = `Sen bir e-ticaret ürün pazarlama uzmanısın. "${collectionTitle}" koleksiyonunda yer alan "${productTitle}" ürünü için çekici, kısa bir başlık oluştur.

Etiketler: ${productTags}

Kurallar:
- Maksimum 8-10 kelime
- Duygusal ve ilgi çekici
- Türkçe
- Ürünün özelliklerini vurgula
- Koleksiyon temasına uygun

Sadece başlığı yaz, başka bir şey ekleme.`;

      try {
        const response = await fetch(OPENAI_PROXY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            messages: [{ role: 'user', content: prompt }],
            temperature: 0.8,
            max_tokens: 50
          })
        });

        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }

        const data = await response.json();
        const generatedTitle = data.choices[0].message.content.trim();

        console.log('✅ Generated title:', generatedTitle);

        // Update UI
        element.textContent = generatedTitle;

        // Cache result
        localStorage.setItem(cacheKey, JSON.stringify({
          title: generatedTitle,
          timestamp: Date.now()
        }));

      } catch (error) {
        console.error('❌ AI generation failed:', error);
        // Keep original title on error
      }
    }
  }

  // Initialize
  new CollectionAIGenerator();

})();

;/* massimo-collection-restore-loader-20260606 */
(function(){try{var p=(location.pathname||'').toLowerCase();if(p.indexOf('/collections/')!==0)return;function u(n){var s=document.currentScript&&document.currentScript.src||'';if(s&&s.indexOf('/assets/')>-1)return s.split('?')[0].replace(/assets\/[^/]+$/,'assets/'+n)+'?massimo_collection_restore=20260606';return '/cdn/shop/t/530/assets/'+n+'?massimo_collection_restore=20260606'}function l(n){if(document.querySelector('script[src*="'+n+'"]'))return;var x=document.createElement('script');x.src=u(n);x.defer=true;document.head.appendChild(x)}l('massimo-collection-render.js');l('massimo-collection-pricing.js')}catch(e){console.warn('[massimo-collection-restore-loader]',e&&e.message||e)}})();
